import { Outlet, useLocation } from "react-router-dom";
import AdminHeader from "./header";
import AdminSidebar from "./sidebar";
import React, { useLayoutEffect } from "react";
import RouteErrorBoundary from "../../Components/RouteErrorBoundary";
import "./adminShell.css";

const AdminLayout = () => {
  const path = useLocation();

  useLayoutEffect(() => {
    const body = document.querySelector("body");
    body?.classList.add("error404", "text-left");
  }, [path]);

  return (
    <>
      <AdminHeader />
      <div className="main-container" id="container">
        <AdminSidebar />

        {/* Mobile overlay — reuses the template's .sidebarCollapse toggle to close */}
        <div className="admin-mobile-overlay sidebarCollapse" aria-hidden="true" />

        <div id="content" className="main-content">
          <div className="layout-px-spacing">
            <div className="layout-top-spacing">
              <RouteErrorBoundary routeKey={path.pathname}>
                <Outlet />
              </RouteErrorBoundary>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminLayout;
